import { BehaviorSubject } from 'rxjs';
import { TOKENS_SWEEPSTAKES_CONFIG } from "../../config/api";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class TokensSweepstakesService {
    constructor(http) {
        this.http = http;
        this.config = TOKENS_SWEEPSTAKES_CONFIG;
        this.visible = new BehaviorSubject(null);
    }
    show() {
        this.visible.next(true);
    }
    hide() {
        this.visible.next(false);
    }
    getData() {
        return this.http.post(this.config.data, {});
    }
}
TokensSweepstakesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TokensSweepstakesService_Factory() { return new TokensSweepstakesService(i0.ɵɵinject(i1.HttpClient)); }, token: TokensSweepstakesService, providedIn: "root" });
